import { Component, OnInit, EventEmitter } from '@angular/core';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { UntypedFormGroup } from '@angular/forms';
import { WorkflowContextService } from 'src/app/services';
import { RenewalReviewActivity } from 'src/app/models/activities/renewal-review-activity';

@Component({
    selector: 'wm-renewal-review-activity-view',
    templateUrl: './renewal-review-activity-view.component.html',
    styleUrls: ['./renewal-review-activity-view.component.css'],
    standalone: false
})
export class RenewalReviewActivityViewComponent
  implements OnInit, ActivityView {
  activity: RenewalReviewActivity;
  isPreview: boolean;
  isTestApplication: boolean;
  showSave?: EventEmitter<boolean>;
  showCancel?: EventEmitter<boolean>;
  showNext?: EventEmitter<boolean>;
  showPrevious?: EventEmitter<boolean>;
  goNext?: EventEmitter<boolean>;
  value$: EventEmitter<any>;
  initActivity: any;
  form: UntypedFormGroup;
  context: WorkflowContextService;
  nextOnSelect = false;
  applicationId?: string;

  viewTitle(): string {
    return 'Review Renewable Application Activity';
  }

  constructor() {}

  ngOnInit() {}
}
